<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer001">
<h1 class="Prelims-head" lang="en-GB"><a id="_idTextAnchor000"></a>About the Author</h1>
<p class="Prelims-main" lang="en-GB">Mary Joseph lives in London, England.</p>
<p class="Prelims-main" lang="en-GB">She shares her busy schedule with family and friends while working in the financial service of a private company, enjoys looking after her bunnies and being a musician. </p>
<p class="Prelims-main" lang="en-GB">She decided to write this book and share her passion with her readers. </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398406179_EPUB.vue?54892941